import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import { Icon } from '../Icon/Icon.component.js';
import ButtonLoader from '../ButtonLoader/ButtonLoader.component.js';
import { propTypes, defaultProps } from './IconButton.types.js';
import styles from './IconButton.module.scss.js';

/**
 * Icon Button
 *
 * A button that displays an Icon inside of it.
 */
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.componentDidMount = function () {
        if (this.props.dataTestId) {
            console.warn('DEPRECATION WARNING: The `dataTestId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
        if (['warning'].includes(this.props.variant || '')) {
            console.warn('DEPRECATION WARNING: Variant `warning` is deprecated and support for it will be removed soon. Please use other variants instead.');
        }
        if ((this.props.size || 0) > 44) {
            console.warn("Icon size can't be bigger than button size. If you want make it bigger than it allowed please use prop 'className'.");
        }
    };
    IconButton.prototype.render = function () {
        var _a = this.props, href = _a.href, onClick = _a.onClick, variant = _a.variant, className = _a.className, buttonProps = _a.buttonProps, disableBorder = _a.disableBorder, isSelected = _a.isSelected, iconClassname = _a.iconClassname, selectedName = _a.selectedName, _b = _a.buttonSize, buttonSize = _b === void 0 ? 'regular' : _b, dataTestId = _a.dataTestId, data_test_id = _a["data-testid"], isLoading = _a.isLoading, iconProps = __rest(_a, ["href", "onClick", "variant", "className", "buttonProps", "disableBorder", "isSelected", "iconClassname", "selectedName", "buttonSize", "dataTestId", 'data-testid', "isLoading"]);
        var variantClass = variant ? styles["IconButton___" + variant] : '';
        var isTertiary = variant === 'tertiary';
        var iconName = isSelected
            ? selectedName || iconProps.name
            : iconProps.name;
        // Render the all the things!
        return (React__default.createElement(ButtonBase, __assign({ href: href, onClick: onClick, className: clsx(styles.IconButton, variantClass, styles["IconButton___" + buttonSize], disableBorder && styles.IconButton___borderless, isSelected && styles.IconButton___selected, isLoading && styles.IconButton___loading, className), "data-testid": data_test_id || dataTestId, "aria-label": iconProps.alt || iconName }, buttonProps),
            React__default.createElement(Icon, __assign({ className: iconClassname || '' }, iconProps, { name: iconName })),
            isTertiary && (React__default.createElement(Icon, { className: styles.IconButton_arrow, name: "ArrowDown", alt: "ArrowDown", size: 18 })),
            isLoading && (React__default.createElement(ButtonLoader, { variant: variant, "data-testid": data_test_id || dataTestId }))));
    };
    IconButton.displayName = 'IconButton';
    IconButton.propTypes = propTypes;
    IconButton.defaultProps = __assign({}, defaultProps);
    return IconButton;
}(React__default.Component));

export { IconButton as default };
